<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 w-100">
        <div class="d-flex align-items-center gap-2">
          <h6 class="modal-title" i18n>Preview Template</h6>
        </div>
        <div class="flex-fill"></div>
      </div>
      <a (click)="close()" class="cstm-close" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div *ngIf="isLoading" class="d-flex justify-content-center mt-5">
        <app-loading-section size="3rem"></app-loading-section>
      </div>
      <pdf-viewer
        [src]="pdfData | async"
        [render-text]="false"
        [original-size]="false"
        [fit-to-page]="true"
        [autoresize]="true"
        (after-load-complete)="onFileLoaded()"
        style="display: block"
      >
      </pdf-viewer>
    </div>
  </div>
</div>
